(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cstm-latest-trending"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    let gliderInstance = null;
    function initOrDestroyGlider() {
    const sliderEl = document.querySelector(".cstm-latest-trending-main-container .blog-cards");
    const isMobile = window.innerWidth < 500;
    if (isMobile && !gliderInstance) {
      // INIT the slider
      const prev = sliderEl.closest('.cstm-latest-trending-main-container').querySelector('.cstm_prev'),
        next = sliderEl.closest('.cstm-latest-trending-main-container').querySelector('.cstm_next')
      gliderInstance = new Glider(sliderEl, {
        slidesToShow: 1,
        slidesToScroll: 1,
        // draggable: true,
        rewind: true,
        arrows: {
          prev: prev,
          next: next
        }
      });
    }
    if (!isMobile && gliderInstance) {
      gliderInstance.destroy();
      gliderInstance = null;
    }
  }
  initOrDestroyGlider();

  window.addEventListener("resize", function () {
    initOrDestroyGlider();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.querySelectorAll('[id^="Details-"].mega-menu summary').forEach((summary) => {
    const details = summary.closest('details');
    let closeTimer;

    summary.addEventListener('click', (e) => {
      e.preventDefault(); // stop default toggle
    });

    summary.addEventListener('mouseover', () => {
      clearTimeout(closeTimer);
      setTimeout(100);
      details.open = true; // required by Dawn
      requestAnimationFrame(() => {
        // ensures repaint before class add
        details.classList.add('cstm_show');
      });
      summary.setAttribute('aria-expanded', 'true');
    });

    details.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => {
        details.classList.remove('cstm_show');
        summary.setAttribute('aria-expanded', 'false');
        setTimeout(() => {
          details.open = false; // close AFTER animation finishes
        }, 200); // match CSS transition time
      }, 200);
    });

    details.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
    });
  });
  $(document).ready(function() {
    $('.header__menu-item, .mega-menu__content').on('mouseenter', function () {
      $(this).closest('details').attr('open', true);
    });
    $('.header__menu-item, .mega-menu__content').on('mouseleave', function () {
      $(this).closest('details').removeAttr('open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  $(document).ready(function () {
    $('.readmore').click(function (event) {
      event.preventDefault();
      $('.product-description-full').slideDown();
      $('.product-description-short').slideUp();
    });
    $('.readless').click(function (event) {
      event.preventDefault();
      $('.product-description-full').slideUp();
      $('.product-description-short').slideDown();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["predictive-search"]) return;
  try {
    
  $(document).ready(function () {
    $('.search__input.field__input').on('focus', function () {
      setTimeout(function () {
        $('.predictive-search.predictive-search--header').css({
          display: 'block',
          height: '480px',
        });
      }, 1000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  function initRelatedSlider() {
    const $slider = $('.related_product_ul');
    if (!$slider.length) return;
    if ($slider.hasClass('slick-initialized')) return;
    $slider.slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: true,
      autoplaySpeed: 3000,
      prevArrow: $('.cstm_prev-relatedProducts'),
      nextArrow: $('.cstm_next-relatedProducts'),
      customPaging: () => '<button class="slick-dot-btn"></button>',
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2, autoplay: true } },
        { breakpoint: 374, settings: { slidesToShow: 1, autoplay: true } },
      ],
    });
  }
  const observer = new MutationObserver(() => {
    const slider = document.querySelector('.related_product_ul');
    if (slider) {
      initRelatedSlider();
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  } catch(e) { console.error(e); }
})();
})();
